import Store from '../../../common/store';

const delegatePluginsStore = new Store<IPlugin.IPluginDelegate[]>([])

export default delegatePluginsStore;
